/**
 * BacktestLogs.js
 *
 * Thin wrapper around the shared LogsViewer component for backtest logs.
 *
 * WHY THIS EXISTS:
 * - Maintains backward compatibility with existing usages
 * - Maps backtestId prop to entityId
 * - Sets entityType='backtest' automatically
 *
 * MIGRATION NOTE:
 * This is now a wrapper around LogsViewer. All features (auto-refresh, search,
 * date filtering, pagination) are inherited from LogsViewer.
 */

import React from 'react';
import PropTypes from 'prop-types';
import LogsViewer from './LogsViewer';

/**
 * BacktestLogs - Display logs from a backtest run
 *
 * @param {string} backtestId - ID of the backtest to fetch logs for
 * @param {function} getApiToken - Function that returns an auth token
 * @param {boolean} expanded - Whether the logs section is expanded
 * @param {function} onToggle - Callback when expand/collapse is triggered
 * @param {boolean} hideToggleButton - Whether to hide the toggle button
 * @param {string} className - Additional CSS classes
 */
const BacktestLogs = ({
  backtestId,
  getApiToken,
  expanded = false,
  onToggle,
  hideToggleButton = false,
  className = '',
}) => {
  return (
    <LogsViewer
      entityId={backtestId}
      entityType="backtest"
      getApiToken={getApiToken}
      expanded={expanded}
      onToggle={onToggle}
      hideToggleButton={hideToggleButton}
      className={className}
      enableDateFilter={true}
      enableSearch={true}
      enableAutoRefresh={true}
      enableLimitSelector={true}
      defaultLimit={500}
    />
  );
};

BacktestLogs.propTypes = {
  backtestId: PropTypes.string.isRequired,
  getApiToken: PropTypes.func.isRequired,
  expanded: PropTypes.bool,
  onToggle: PropTypes.func,
  hideToggleButton: PropTypes.bool,
  className: PropTypes.string,
};

export default BacktestLogs;
